import { GoogleAuthProvider } from 'firebase/auth';

const googleAuthProvider = new GoogleAuthProvider();

// See your personal info, including any personal info you've made publicly available
// https://developers.google.com/identity/protocols/oauth2/scopes#oauth2
googleAuthProvider.addScope('https://www.googleapis.com/auth/userinfo.profile');

export default googleAuthProvider;
